import { Button, Link } from '@chakra-ui/react';

const HelpButton = () => {
  return (
    <Link
      href="mailto:contact@withloma.com?subject=Help With Loma"
      position="fixed"
      bottom={{ base: 4, md: 8 }}
      right={{ base: 4, md: 8 }}
      zIndex={1000}
      _hover={{ textDecoration: 'none' }}
    >
      <Button
        bgColor="#1AE098"
        size={{ base: 'sm', md: 'md' }}
        shadow="lg"
        rounded="full"
        color="#145154"
        _hover={{
          shadow: 'xl',
        }}
        transition="all 0.2s"
      >
        Having trouble?
      </Button>
    </Link>
  );
};

export default HelpButton;
